import React, { useState, useEffect, useRef } from 'react'

export function GoalLink({ value = null, onChange, disabled = false, activeGoals = [] }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  const linkedGoal = activeGoals.find((g) => g.goalId === value)
  const fullTitle = linkedGoal?.title ?? 'no goal'
  const buttonLabel = linkedGoal && fullTitle.length > 5 ? fullTitle.slice(0, 5) + '…' : fullTitle
  const buttonStyle = linkedGoal
    ? { ...pillStyles.base, background: '#EAF3DE', color: '#173404' }
    : { ...pillStyles.base, background: '#F1EFE8', color: '#5F5E5A' }

  useEffect(() => {
    if (!open) return
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    const handleKey = (e) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', handleKey)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleKey)
    }
  }, [open])

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={() => !disabled && setOpen(!open)}
        disabled={disabled}
        style={buttonStyle}
        title={fullTitle}
        aria-label={`Linked goal: ${fullTitle}. Click to change.`}
        aria-expanded={open}
        aria-haspopup="menu"
      >
        {buttonLabel}
      </button>

      {open && (
        <div
          role="menu"
          style={dropdownStyles.menu}
        >
          {activeGoals.map((goal) => (
            <button
              key={goal.goalId}
              role="menuitem"
              onClick={() => { onChange(goal.goalId); setOpen(false) }}
              style={{
                ...dropdownStyles.item,
                background: goal.goalId === value ? '#EAF3DE' : 'transparent',
              }}
            >
              {goal.title}
            </button>
          ))}
          <div style={dropdownStyles.divider} />
          <button
            role="menuitem"
            onClick={() => { onChange(null); setOpen(false) }}
            style={{
              ...dropdownStyles.item,
              color: '#5F5E5A',
              background: value == null ? '#f1efe8' : 'transparent',
            }}
          >
            no goal
          </button>
        </div>
      )}
    </div>
  )
}

const pillStyles = {
  base: {
    fontSize: '9px',
    fontWeight: 500,
    padding: '2px 7px',
    borderRadius: '10px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'opacity var(--duration-fast) ease',
    border: 'none',
  },
}

const dropdownStyles = {
  menu: {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: 4,
    background: 'white',
    border: '0.5px solid #e8e6de',
    borderRadius: 8,
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    padding: 4,
    minWidth: 200,
    maxWidth: 280,
    zIndex: 10,
  },
  item: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: '6px 10px',
    border: 'none',
    borderRadius: 4,
    fontSize: 12,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  divider: {
    borderTop: '0.5px solid #e8e6de',
    margin: '4px 0',
  },
}
